(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-purchase-order"]) return;
  try {
    
  // HTML input elements

  // HTML elements
  const fileInput = document.getElementById('upload-document');
  const endpoint = `${api_token}/upload`;
  const endpointDraftOrder = `${api_token}/create/draft-order`;
  const customer_id = window.customerId; //document.querySelector('#customer_id');
  const uploadForm = document.querySelector('#po_form');
  const response_container = document.querySelector('.response_container');
  const {shopify_company_id} = sessionCustomerData;


  fileInput?.addEventListener('change', () => {
    event.preventDefault();
    uploadImage();
  });
  uploadForm?.addEventListener('submit', () => {
    event.preventDefault();
    draftOrder();
  });

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const draftOrder = async () => {
    filePath = window.uploadfilePath;
      const companyContactId = sessionCustomerData?.companyContactProfiles[0].id
      

    const comment = document.querySelector('#comment').value;
    // const shippingAddress = document.querySelector('#shipping-address').value;
    // const address_object = parseAddress(shippingAddress);
    const location_id = document.getElementById("location_id").value;
    
    const requestObject = {
      filePath:filePath,
      comment:comment,
      customer_id: customer_id,
      companyId:shopify_company_id,
      companyLocationId: location_id,
      companyContactId: companyContactId

    };
    console.log(requestObject);
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', 'eyJhbGciOiJIUzI1NiJ9.YWRtaW4.ERR1q_bnERccOVOR1NHJpimKZOJVogpA_VyrCU_7kQE');
    const response = await fetch(endpointDraftOrder, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(requestObject),
    }).then((res) => {
      
      document.querySelector('.left-content').style.display = 'none';
      document.querySelector('.response_container').style.display = 'block';
      document.getElementById('po_form').reset();
    });
  };
  //upload code uploaded.
  const uploadImage = async () => {

    const base64 = await convertBase64(fileInput.files[0]);
    fileContents = base64.replace('data:application/pdf;base64,', '');
    const filename = fileInput.files[0].name;
    document.getElementById('image_loader').style.display = 'block';
    
    const requestObject = {
      file: fileContents,
      fileName: filename,
      customer: customer_id,
    };
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', 'eyJhbGciOiJIUzI1NiJ9.YWRtaW4.ERR1q_bnERccOVOR1NHJpimKZOJVogpA_VyrCU_7kQE');

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(requestObject),
    })
      .then((res) => res.json())
      .then((response) => {
        // Check if the response status is successful
        if (response && response?.status == 'success') {
          window.uploadfilePath = response.path;
          document.getElementById('btnCreatePo').disabled = false;
          document.getElementById('image_loader').style.display = 'none';

          document.getElementById(
            'pdf_preview'
          ).src = `https://docs.google.com/viewer?url=${response.path}&embedded=true`;
        } else {
          ocument.querySelector('#upload_status_message').innerHTML = error.message;
          console.log('Error', response.status);
        }
      });
    
    
  };

  } catch(e) { console.error(e); }
})();

})();
